import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../../auth/components/DialogHeader";
import DatePickerLocalizationAdapter from "../../../main/context/DatePickerLocalizationAdapter";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { CardIntervalOptionsEnum } from "../../dashboard/types";

export default function DateFilterModal(props: {
  date: Date | dayjs.Dayjs | null;
  setDate: (startDate: dayjs.Dayjs | null) => void;
  setOpen: (open: boolean) => void;
  open: boolean;
  title: string;
  interval: CardIntervalOptionsEnum
  onCLick?: () => void;
  titleButton?: string
}) {
  const { date, setDate, interval, title, open, setOpen, onCLick, titleButton } =
    props;
  const onClose = () => setOpen(false);
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "400px",
          maxHeight: "600px",
        },
      }}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        <Typography
          sx={{
            fontSize: {
              xs: "1rem",
              sm: "1.5rem",
            },
            fontWeight: 500,
          }}
        >
          {title}
        </Typography>
      </DialogHeader>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          overflowY: "auto",
        }}
        dividers
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: "8px",
          }}
        >
          <DatePickerLocalizationAdapter>
            <DatePicker
              format={interval == CardIntervalOptionsEnum.Mes ? "MM/YYYY" : "DD/MM/YYYY"}
              views={interval == CardIntervalOptionsEnum.Mes ? ["month", "year"] : undefined}
              slotProps={{ textField: { size: "small" } }}
              maxDate={dayjs(new Date())}
              sx={{ marginRight: "8px" }}
              label="Data"
              value={dayjs(date)}
              onChange={(newValue) => setDate(newValue)}
            />
          </DatePickerLocalizationAdapter>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => { onCLick && onCLick(); onClose() }}
        >
          {titleButton ? titleButton : "Filtrar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
